import styled from 'styled-components';
interface TabContainerProps {
  $active: boolean;
}
export const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const Icon = styled.div`
  height: 16px;
  width: 16px;
  margin-right: 5px;
`;

export const TabContainer: any = styled.div<TabContainerProps>`
  padding: 10px 14px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: ${({ $active, theme }) =>
    $active
      ? `linear-gradient(99deg, ${theme.switchResults.active.background}, ${theme.switchResults.active.background})`
      : `${theme.switchResults.inactive.background}`};
  margin-right: 1px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;

  & ${Label} {
    color: ${({ $active, theme }) => ($active ? theme.switchResults.active.color : theme.switchResults.inactive.color)};
  }

  & ${Icon} {
    color: ${({ $active, theme }) => ($active ? theme.switchResults.active.color : theme.switchResults.inactive.color)};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;
